import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', Config])

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.deudoresDiversosEgresos', {
    url: '/deudoresDiversosEgresos?{fecha_inicio:date}&{fecha_fin:date}&:idOperadora&:ids_empresas',
    template,
    data: {
      title: 'Deudores Diversos Egresos',
    },
    params: {
      ids_empresas: {
        array: true,
      },
    },
    resolve: {
      empresas: ['$catalogos', '$stateParams', function ($catalogos, $stateParams) {
        var empresasSeleccionadas = $stateParams.ids_empresas || []

        return $catalogos.get('empresas').then(function (empresas) {
          return empresas.map(function (item) {
            item.seleccionado = empresasSeleccionadas.indexOf(item.ID_Empresa) >= 0
            return item
          })
        })
      }],
      polizas: ['deudoresDiversosEgresosService', '$stateParams', function (deudoresDiversosEgresosService, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_empresas = $stateParams.ids_empresas

        return fecha_inicio && fecha_fin && ids_empresas ? deudoresDiversosEgresosService.obtenerInformacionDeudoresDiversosEgresos(
          fecha_inicio,
          fecha_fin,
          ids_empresas,
        ) : undefined
      }],
    },
    controllerAs: '$ctrl',
    controller: Controller,
  })
}

Controller.$inject = ['polizas', '$dialog', '$stateParams', '$location']

function Controller (polizas, $dialog, $stateParams, $location) {
  var $ctrl = this

  $ctrl.data = polizas ? polizas.data : undefined
  $ctrl.divisas = polizas ? polizas.divisas : undefined
  if ($ctrl.data) {
    $ctrl.nuevoData = ordenarArray($ctrl.data)
  }
  $ctrl.Filtro = undefined

  $ctrl.opciones = {
    fecha_inicio: $stateParams.fecha_inicio || new Date(),
    fecha_fin: $stateParams.fecha_fin || new Date(),
    id_operadora: $stateParams.idOperadora || undefined,
    ids_empresas: $stateParams.ids_empresas || [],
  }

  $ctrl.obtenerInformacionDeudoresDiversosEgresos = obtenerInformacionDeudoresDiversosEgresos
  $ctrl.exportar = exportar
  $ctrl.actualizarEmpresas = actualizarEmpresas

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.nuevoData,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        archivo: ' Deudores Diversos Egresos ' + $ctrl.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'deudoresDiversosEgresos',
      },
    })
  }

  function obtenerInformacionDeudoresDiversosEgresos () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      idOperadora: $ctrl.opciones.id_operadora,
      ids_empresas: $ctrl.opciones.ids_empresas,
    })
  }

  function actualizarEmpresas (data) {
    $ctrl.opciones.ids_empresas = data.ids_empresas
    $ctrl.opciones.id_operadora = data.idOperadora
  }

  function ordenarArray (data) {

    var nuevoData = [],
      aux = [],
      totalCargo = 0,
      totalAbono = 0,
      totalComple = 0,
      referencias = [],
      Descripcion,
      Notas,
      Banco_Numero_Cuenta,
      Cuenta_Contable,
      Cuenta_Contable_Complementaria,
      Banco,
      Tipo_Moneda,
      Banco_Referencia,
      Captura_Fecha,
      Fecha_Movimiento,
      totalBanco = 0,
      Divisa

    if (data.length > 0) {
      data.forEach(function (item) {
        if (referencias.indexOf(item.Banco_Referencia) === -1) {
          referencias.push(item.Banco_Referencia)
        }
      })

      referencias.forEach(function (item) {
        data.forEach(function (ele) {
          if (item === ele.Banco_Referencia) {
            aux.push(ele)
            Descripcion = ele.Descripcion
            Banco = ele.Banco
            Banco_Numero_Cuenta = ele.Banco_Numero_Cuenta
            Cuenta_Contable_Complementaria = ele.Cuenta_Contable_Complementaria
            Banco_Referencia = ele.Banco_Referencia
            Tipo_Moneda = ele.Tipo_Moneda
            Divisa = ele.Divisa
            Captura_Fecha = ele.Captura_Fecha
            Cuenta_Contable = ele.Cuenta_Contable
            Fecha_Movimiento = ele.Fecha_Movimiento
            totalBanco += ele.Importe
            totalCargo += ele.Tipo_Moneda === '1' ? ele.Importe : ele.ImpDiv
            totalAbono += (ele.Comple + ele.Importe)
            totalComple += ele.Comple
          }
        })

        nuevoData.push({
          Banco_Numero_Cuenta: Banco_Numero_Cuenta,
          Cuenta_Contable: Cuenta_Contable,
          Cuenta_Contable_Complementaria: Cuenta_Contable_Complementaria,
          Divisa: Divisa,
          Fecha_Movimiento: Fecha_Movimiento,
          Banco: Banco,
          Tipo_Moneda: Tipo_Moneda,
          TotalCargo: totalCargo,
          TotalAbono: totalAbono,
          TotalBanco: totalBanco,
          Captura_Fecha: Captura_Fecha,
          TotalComple: totalComple,
          Descripcion: Descripcion,
          Banco_Referencia: Banco_Referencia,
          cuentas: aux,
        })

        aux = []
        totalCargo = 0
        totalAbono = 0
        totalComple = 0
        totalBanco = 0
      })
    }
    return nuevoData
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/deudoresdiversosegresos/component.js